// extracted by mini-css-extract-plugin
module.exports = {"carticon":"header_carticon__1N9oS","logo":"header_logo__14tHM","header":"header_header__3fn4i"};